export default __webpack_public_path__ + "static/media/DSC_7930.1a8af8c3.jpg";